<app-loading
  [loading] = loading
></app-loading>
<div class="row">
  <div class="col-md-12">
    <app-tabela titulo="Lista de Empresas"
                placeHolder="Buscar empresa"
                [colunas]="colunas"
                [linhas]="linhas"
                [botaoEditar]="false"
    ></app-tabela>
  </div>
</div>
